export default function createRefreshTokenLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `refresh-token:${input.type}` });
    return {
        received(sender) {
            return log({ type: "received", details: { sender } });
        },
        refreshed(success, status) {
            return log({
                type: "refreshed",
                details: { success, status },
            });
        },
        stored() {
            return log({
                type: "stored",
            });
        },
        cleared() {
            log({
                type: "cleared",
            });
        },
    };
}
